export enum FeedbackVote {
  PositiveVote = 'Yes, it did',
  NegativeVote = 'No, it didn’t',
}
